<div>
  <p>{{text}}</p>
  <p *ngIf="!isShowAllText">{{showAllText}}</p>
</div>
